module.exports = __webpack_public_path__ + "img/banner-ver-2.0.33726dce.png";